import '../index.scss';
import { useState, FC } from 'react';
import { useSelector } from 'react-redux';
import { IconButton, Popover, Badge } from '@material-ui/core';
import { DateFilterContainer } from '../FilterByDate';
import { FilterByName } from '../FilterByName';
import { FilterBySelect } from '../FilterBySelect';
import { MgState, HeadCell } from '@types';
import { LangEnum } from '@enums';
import { isFilterAppliedSelectorFactory } from '@selectors/answer';
import { FilterByStatus } from '@components/Pages/AnswersPage/TableHeader/FilterByStatus';
import { FilterBigIcon } from '@images/icons';

interface TableFiltersLabelProps {
  data: HeadCell;
  testId: string;
}

export const TableFiltersLabel: FC<TableFiltersLabelProps> = ({ data, testId }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const lang = useSelector<MgState, LangEnum>(({ app }) => app.lang);
  const isFilterApplied = useSelector(isFilterAppliedSelectorFactory(data.filterKeys));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="table-filter-label">
      <IconButton
        aria-describedby="filters"
        size="small"
        color="primary"
        aria-label="filtering"
        data-testid={testId}
        component="div"
        onClick={handleClick}
      >
        <Badge color="secondary" variant="dot" overlap="circular" invisible={isFilterApplied}>
          <FilterBigIcon />
        </Badge>
      </IconButton>

      {data.filterType === 'text' && (
        <Popover
          id={data.id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <FilterByName data={data} />
        </Popover>
      )}
      {data.filterType === 'date' && (
        <Popover
          id={data.id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <DateFilterContainer setAnchorEl={setAnchorEl} />
        </Popover>
      )}
      {data.filterType === 'select' && (
        <FilterBySelect
          id={`${data.id}-${lang}`}
          anchorEl={anchorEl}
          open={open}
          handleClose={handleClose}
          setAnchorEl={setAnchorEl}
        />
      )}
      {data.filterType === 'status' && (
        <FilterByStatus
          id={`${data.id}-${lang}`}
          anchorEl={anchorEl}
          open={open}
          handleClose={handleClose}
          setAnchorEl={setAnchorEl}
        />
      )}
    </div>
  );
};
